export default __webpack_public_path__ + "static/media/contactscreen.dfeb4927.png";